import { getLifecycle } from 'service/utils';
const REDUCER_NAME = 'WALLET';
export const WALLET_SIMULATE_BUY = getLifecycle(REDUCER_NAME, 'SIMULATE_BUY');
export const WALLET_SIMULATE_SELL = getLifecycle(REDUCER_NAME, 'SIMULATE_SELL');